

import {  
  loadEventLogDataInProgress,
  loadEventLogDataSuccess,
  loadEventLogDataFailure,
  eventLogOperationCompleted
} from "../state/eventlogfiles/actions";
import { oktaAuth } from '../auth/okta';
import { errorSweetAlert } from "../components/SweetAlertMessages";
import swal from "sweetalert";
const serverBasePath=process.env.REACT_APP_SERVER_API_URL;
let abortController = null;

export const loadEventLogFiles = (serialNumber,searchBy) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    if (abortController) {
        abortController.abort();
    }
    abortController = new AbortController();
    const signal = abortController.signal;
    try {
      dispatch(loadEventLogDataInProgress());
      const response = await fetch(serverBasePath+"/file/eventLogFiles?serialNumber="+serialNumber+"&searchBy="+searchBy,
      {  
        signal, 
        method: "GET",
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        }
      });
      const data = await response.json();
      dispatch(eventLogOperationCompleted()); 
      if(response.status !== 200){
        swal("Error", data?.error?.message, "error");
        return;
      }
      dispatch(loadEventLogDataSuccess(data));    
    } catch (e) {
      dispatch(loadEventLogDataFailure());   
      if (e.name === "AbortError") {
        //errorSweetAlert({message:'The operation was aborted.'}); 
      }
    }
};

export const downloadEventLogFile = (rowId,fileName) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken();
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadEventLogDataInProgress());
          const response = await fetch(serverBasePath+"/file/"+rowId+"/eventLogs/download",{
          method: "GET",
          headers: {
              Authorization: 'Bearer ' + token,
          }});
          dispatch(eventLogOperationCompleted()); 
          if(response.status === 500){
            const errorMessage = { error: { code: 'SERVER_ERROR', message: 'Internal Server Error' }};
            dispatch(errorSweetAlert(errorMessage));
            return
          }
          const blob = await response.blob();
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download',fileName); 
          document.body.appendChild(link);
          link.click();
      } catch (e) {   
          dispatch(loadEventLogDataFailure());
          errorSweetAlert(e)
      }
  };
};